import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Mic, Cpu, Send, RefreshCw, ArrowRight } from 'lucide-react';
export function LivableBooksSection() {
  const steps = [{
    icon: <Mic size={20} data-id="element-137" />,
    title: 'Capture',
    desc: 'Talks, workshops, experiences'
  }, {
    icon: <Cpu size={20} data-id="element-138" />,
    title: 'Transform',
    desc: 'Into structured content'
  }, {
    icon: <Send size={20} data-id="element-139" />,
    title: 'Deliver',
    desc: 'Dynamically to each user'
  }, {
    icon: <BookOpen size={20} data-id="element-140" />,
    title: 'Learn',
    desc: 'From user interaction'
  }, {
    icon: <RefreshCw size={20} data-id="element-141" />,
    title: 'Evolve',
    desc: 'Continuously update'
  }];
  return <section id="products" className="py-24 bg-gray-900 text-white overflow-hidden" data-id="element-142">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-144">
          <h2 className="text-teal-400 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-145">
            Core Innovation
          </h2>
          <h3 className="text-4xl font-bold mb-6" data-id="element-146">Livable Books</h3>
          <p className="text-xl text-gray-300 mb-4" data-id="element-147">
            Knowledge that evolves with you.
          </p>
          <p className="text-gray-400" data-id="element-148">
            Traditional content is static. Livable Books are dynamic. They are
            personalized to each reader, continuously updated through
            interaction, and enhanced by AI agents and community feedback.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto" data-id="element-149">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-800 -translate-y-1/2 z-0" data-id="element-150"></div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6 relative z-10" data-id="element-151">
            {steps.map((step, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.1
          }} className="bg-gray-800 p-6 rounded-xl border border-gray-700 text-center flex flex-col items-center hover:border-teal-500 transition-colors" data-id="element-152">
                <div className="w-12 h-12 bg-gray-900 rounded-full flex items-center justify-center text-teal-400 mb-4 border border-gray-700" data-id="element-153">
                  {step.icon}
                </div>
                <h4 className="font-bold text-white mb-2" data-id="element-154">{step.title}</h4>
                <p className="text-sm text-gray-400" data-id="element-155">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-156">
          <div className="inline-block bg-gray-800 border border-gray-700 px-6 py-3 rounded-full mb-8" data-id="element-157">
            <span className="text-amber-400 font-medium" data-id="element-158">Result:</span> A book
            that never ends. A system that keeps learning.
          </div>
          <div data-id="element-159">
            <button className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-500 text-white px-8 py-4 rounded-md font-semibold transition-colors" data-id="element-160">
              Build Your First Livable Book
              <ArrowRight size={20} data-id="element-161" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}